import axios from "axios";
import { logError } from "@/lib/logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pas_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const STATUSES = ["MASUK", "ON PROSES", "SELESAI", "DITERIMA"];

export const KATEGORI = [
  "A3",
  "DESAIN",
  "DTF KAOS",
  "DTF UV",
  "INDOOR",
  "LASSER",
  "OUTDOOR",
  "PROJEK",
  "SUBLIM",
];

export const KATEGORI_EXTRA_PENGELUARAN = ["SETOR", "GAJI", "OPERASIONAL KANTOR"];

export const loadKategoriPengeluaran = async () => {
  try {
    const { data } = await api.get("/kategori-pengeluaran");
    return data.filter((k) => k.active).map((k) => k.name);
  } catch (error) {
    logError("Gagal memuat kategori pengeluaran, memakai daftar bawaan:", error);
    return KATEGORI_EXTRA_PENGELUARAN;
  }
};

export const loadKategori = async () => {
  try {
    const { data } = await api.get("/kategori");
    const active = data.filter((k) => k.active).map((k) => k.name);
    if (active.length) KATEGORI.splice(0, KATEGORI.length, ...active);
  } catch (error) {
    logError("Gagal memuat daftar kategori, memakai daftar bawaan:", error);
  }
  return KATEGORI;
};

export const STATUS_STYLE = {
  MASUK: "text-amber-300 bg-amber-400/10 border-amber-400/30",
  "ON PROSES": "text-blue-300 bg-blue-400/10 border-blue-400/30",
  SELESAI: "text-emerald-300 bg-emerald-400/10 border-emerald-400/30",
  DITERIMA: "text-slate-200 bg-slate-700/40 border-slate-500/40",
};

export const COMPANY = {
  name: "PAS PERCETAKAN",
  tagline: "Advertising · Digital Printing · Cirebon",
  welcome: "SELAMAT DATANG DI GAPURA PAS PERCETAKAN",
  welcomeSub: "mari berbuat baik dan selalu enjoy",
  address:
    "Jl. Sultan Ageng Tirtayasa No.21, Kedungjaya, Kec. Kedawung, Kabupaten Cirebon, Jawa Barat 45153",
  phone: "08112212190",
  email: "marketingpasmedsos@gmail.com",
  waLink: "https://wa.me/628112212190",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_jo-tracking-system/artifacts/fnht357x_607f7295-64ff-44bd-9c0d-6c0c0ef9add1.png",
};

export const mediaUrl = (m) =>
  m.source === "upload" ? `${BACKEND_URL}${m.url}` : m.url;

export const fmtDate = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
};

export const fmtDateTime = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return d;
  }
};
